import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function(element) {
    gsap.from(element.querySelector(".grass-1"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
            // toggleActions: "play none play none",
        },
        // y: 80,
        scale: 0.2,
        opacity: 0,
        duration: 2,
        ease: "power4.out",
    });
    gsap.from(element.querySelector(".grass-2"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
        },
        // x: 180,
        // y: -250,
        scale: 0.4,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
    });
};